import React, { Component } from "react";
import RoleMember from "../RoleMember";
import { dataUser } from "../Helpers/util";
import { Navigate } from "react-router-dom";

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
var FormData = require('form-data');

class ManageRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userRole: (UserObj && UserObj.role_data) ? UserObj.role_data: [],
    }
  }
  render() {

    const ManageRoles = this.state.userRole.find(element => element.service_id=='13' && (element.role_for_read==='1' || element.role_for_write==='1'))
   
    if (!ManageRoles) {
      return <Navigate to='/Dashboard' />
    }

   
    return (
      <>
        <RoleMember />
      </>
    );
  }
}


export default ManageRoles;
